// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bold-text[data-v-b861281e] {\n  font-weight: bold;\n}\n.subtext[data-v-b861281e] {\n  font-size: 10px;\n}", ""]);
// Exports
module.exports = exports;
